import type { IconNode } from '../types';

/**
 * @name slot-card
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNyAxM0g0YTIgMiAwIDAgMS0yLTJWN2EyIDIgMCAwIDEgMi0yaDE2YTIgMiAwIDAgMSAyIDJ2NGEyIDIgMCAwIDEtMiAyaC0zIiAvPgogIDxwYXRoIGQ9Ik02IDloMTIiIC8+CiAgPHBhdGggZD0ibTEzIDkgNCA0djRhMiAyIDAgMCAxLTIgMkg5YTIgMiAwIDAgMS0yLTJWOSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/slot-card
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const slotCard: IconNode = [
  [
    'path',
    {
      d: 'M7 13H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-3',
      key: 's0ohus',
    },
  ],
  ['path', { d: 'M6 9h12', key: 'oae0tv' }],
  ['path', { d: 'm13 9 4 4v4a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9', key: '1egr9b' }],
];

export default slotCard;
